import { isTauri } from '@/tauri/utils';
import { logger } from '@/utils/logger/logger';
import { invoke } from '@tauri-apps/api/core';

/** Returns `true` exactly once per install. Errors swallowed as `false`. */
export async function claimInstallMarker(): Promise<boolean> {
  if (!isTauri()) return false;
  try {
    return await invoke<boolean>('claim_install_marker');
  } catch (error) {
    logger.error('[installTracking] claim failed', (error as Error)?.message);
    return false;
  }
}
